import { render, staticRenderFns } from "./DowngradeReasonSelector.vue?vue&type=template&id=55f821fb&scoped=true&"
import script from "./DowngradeReasonSelector.vue?vue&type=script&lang=js&"
export * from "./DowngradeReasonSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f821fb",
  null
  
)

export default component.exports